import { styled } from '@mui/material';

interface StyledFilesUploadProps {
  hasItems?: boolean;
  isForAddresses?: boolean;
}

export const StyledFilesUpload = styled('div')<StyledFilesUploadProps>(
  ({ hasItems, isForAddresses }) => ({
    backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23333' stroke-width='1.8' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e") !important`,
    background: '#FFF',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: isForAddresses ? '8.125rem' : hasItems ? '8.125rem' : '16.25rem',
    '& .MuiTypography-root ': {
      fontSize: hasItems ? '0.8125rem' : undefined,
      textAlign: hasItems ? 'center' : undefined,
    },
    padding: '1.25rem',
    marginBottom: '0.625rem',
    cursor: 'pointer',
  }),
);

export default StyledFilesUpload;
